<template>
  <div class="arborescence">
        <ul :class="getCSSClass(elem)" class="uk-text-left uk-margin-small-left uk-padding-remove"
        v-for="(elem, index) in element.elements"
        :key="index"
        uk-nav>
          <li :class="isCSSClassParent(elem)" class="uk-text-left">
            <a class="uk-padding-remove uk-text-truncate" v-on:click="hasChild(elem) ? didPressNomenclature(elem) : ''">{{elem.title}}</a>
            <ul>
              <li>
                <Arborescence :id="elem.uid" @didPressNomenclature="didPressNomenclature" :element="elem" v-if="hasChild(elem)"></Arborescence>
              </li>
            </ul>
          </li>
        </ul>
  </div>
</template>

<script>
import ElementType from "../enums/element-type";

export default {
  name: "Arborescence",
  props: ["element"],
  data() {
    return {
      isConnected: true,
      currentUser: {}
    };
  },
  mounted() {
    // init
  },

  methods: {
    hasChild: function(element) {
      return element.elements !== undefined && element.type === ElementType.ELEMENT
    },

    getCSSClass: function(element) {
      return element.type == ElementType.ATTRIBUTE
        ? "uk-nav-sub"
        : "uk-nav-default uk-nav-parent-icon";
    },

    isCSSClassParent: function(element) {
      return element.type == ElementType.ATTRIBUTE ? "" : "uk-parent uk-margin-small-left";
    },

    didPressNomenclature: function(element) {
      this.$emit('didPressNomenclature', element)
    }

  }
};
</script>

<style scoped>
</style>
